// extracted by mini-css-extract-plugin
module.exports = {"section":"structure-module--section--IXFfz","container":"structure-module--container--2QBzL"};